module.exports = __webpack_public_path__ + "img/2012-12-14 20.12.49.11bf9e30.jpg";